var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PublicHeader',{attrs:{"totalName":_vm.title}}),_c('div',{style:('position: relative;margin-top: 44px;width: 100%;height:' + _vm.pageHeight + 'px;'),attrs:{"id":"myIframe"}},[_c('iframe',{attrs:{"src":_vm.getPageUrl,"width":"100%","height":"100%","frameborder":"0","scrolling":"auto"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }